import { Link } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Input from "../../Inputs/Input";
import MainButton from "../../Buttons/MainButton";

interface DecisionsProps {}

const Decisions: React.FC<DecisionsProps> = () => {
  return (
    <>
      <Row>
        <Col>
          <Title title="ادخال قرارات" />
        </Col>
      </Row>
      <Row justify={"center"}>
        <Col lg={11} md={11} sm={11}>
          <Input placeholder="ادخل الرقم الامتحاني" />
        </Col>
      </Row>
      <Row>
        <Col lg={5} md={5} sm={11} className="flex justify-end !mt-4">
          <Link to="/decisions/all_decisions">
            <MainButton titlebtn="كافة القرارات" className="w-[400px]" />
          </Link>
        </Col>
        <Col
          lg={6}
          md={5}
          sm={11}
          className="flex lg:justify-end max-lg:mx-auto  !mt-4 "
        >
          <Link to="/decisions/enter_decisions">
            <MainButton titlebtn="استعلام" className="w-[400px]" />
          </Link>
        </Col>
      </Row>
    </>
  );
};

export default Decisions;
